import React from "react";

export default function BirthdayFrame2({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1500 1500"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-2bi1{fill:#9e4784}.cls-2bi2{fill:#37306b}.cls-2bi3{fill:#d27685}"
            }
          </style>
        </defs>
        <path d="M807.87 204.88h18.93v100.49h-18.93z" className="cls-2bi3" />
        <path
          d="M826.8 214.8v10.55l-18.93 5.26v-10.55l18.93-5.26zM826.8 234.81v10.55l-18.93 5.26v-10.55l18.93-5.26zM826.8 254.84v10.55l-18.93 5.25v-10.55l18.93-5.25zM826.8 274.86v10.55l-18.93 5.26v-10.55l18.93-5.26z"
          className="cls-2bi2"
        />
        <path
          d="M810.33 198.87c-3.85-5.24-.47-17.75 9.2-30.96.12 3.63.55 8.6 1.9 14.29 2.39 10.09 5.63 13.74 4.07 16.78-2.12 4.12-11.74 4.55-15.16-.11Z"
          className="cls-2bi3"
        />
        <path d="M670 201.89h18.93v100.49H670z" className="cls-2bi2" />
        <path
          d="M688.93 211.81v10.55L670 227.62v-10.55l18.93-5.26zM688.93 231.83v10.55L670 247.63v-10.55l18.93-5.25zM688.93 251.85v10.55L670 267.66v-10.55l18.93-5.26zM688.93 271.87v10.55L670 287.68v-10.55l18.93-5.26z"
          className="cls-2bi1"
        />
        <path
          d="M672.46 195.88c-3.85-5.24-.47-17.75 9.2-30.96.12 3.63.55 8.6 1.9 14.29 2.39 10.09 5.63 13.74 4.07 16.78-2.12 4.12-11.74 4.55-15.16-.11Z"
          className="cls-2bi3"
        />
        <path
          d="M965.44 1037.21H547.45c-24.04 0-43.6-19.56-43.6-43.6V575.62c0-24.04 19.56-43.6 43.6-43.6h417.99c24.04 0 43.6 19.56 43.6 43.6v417.99c0 24.04-19.56 43.6-43.6 43.6ZM547.45 553.02c-12.46 0-22.6 10.14-22.6 22.6v417.99c0 12.46 10.14 22.6 22.6 22.6h417.99c12.46 0 22.6-10.14 22.6-22.6V575.62c0-12.46-10.14-22.6-22.6-22.6H547.45ZM1098.47 1175.27l-2.31 16.05c-.98 6.78-1.95 13.56-2.93 20.33-1.59 11.09-3.19 22.18-4.79 33.26-.98 6.78-1.95 13.56-2.93 20.33a33219.6 33219.6 0 0 1-4.79 33.25c-.98 6.78-1.95 13.56-2.93 20.34-1.29 8.98-2.59 17.95-3.88 26.92-.93 6.47-5.97 11.23-11.9 11.23H447.64c-5.11 0-9.67-3.58-11.37-8.9-3.73-11.68-6.73-21.11-9.33-29.25-2.44-7.65-4.52-14.17-6.49-20.34-3.41-10.71-6.5-20.4-10.61-33.25l-6.49-20.33c-.41-1.31-.84-2.65-1.28-4.03-2.62-8.22 2.49-16.96 10.35-17.7l122.67-11.53 216.29-20.33 334.17-31.41c7.8-.73 14.15 6.82 12.92 15.36Z"
          className="cls-2bi2"
        />
        <path
          d="M1076.31 1051.5h-640.3c-12.32 0-22.31 9.34-22.31 20.87v106.06c0 12.33 11.37 21.98 24.48 20.77l634.36-58.23c10.45-.96 18.77-8.6 19.98-18.36l5.94-47.83c1.54-12.4-8.82-23.28-22.16-23.28Z"
          className="cls-2bi3"
        />
        <path
          d="M1080.72 1298.49c-.98 6.78-1.95 13.56-2.93 20.34H426.94c-2.44-7.65-4.52-14.17-6.49-20.34h660.27ZM1088.44 1244.91c-.98 6.78-1.95 13.56-2.93 20.33H409.84l-6.49-20.33h685.09ZM1096.16 1191.32c-.98 6.78-1.95 13.56-2.93 20.33H535.09l216.29-20.33h344.78Z"
          className="cls-2bi1"
        />
        <circle cx={463.03} cy={1117.7} r={32.1} className="cls-2bi2" />
        <circle cx={559.23} cy={1080.25} r={13.91} className="cls-2bi2" />
        <circle cx={720.85} cy={1125.41} r={13.91} className="cls-2bi2" />
        <circle cx={1004.91} cy={1124.22} r={13.91} className="cls-2bi2" />
        <circle cx={878.92} cy={1103.92} r={32.23} className="cls-2bi2" />
        <circle cx={620.79} cy={1148.72} r={23.31} className="cls-2bi2" />
        <path d="M735.65 183.53h23.78v110.11h-23.78z" className="cls-2bi1" />
        <circle cx={669.93} cy={1075.85} r={11.13} className="cls-2bi2" />
        <circle cx={1037.9} cy={1080.25} r={11.13} className="cls-2bi2" />
        <circle cx={958.29} cy={1080.25} r={5.56} className="cls-2bi2" />
        <circle cx={921.42} cy={1119.82} r={5.56} className="cls-2bi2" />
        <circle cx={1071.29} cy={1115.66} r={5.56} className="cls-2bi2" />
        <circle cx={810.06} cy={1149.8} r={5.56} className="cls-2bi2" />
        <circle cx={559.23} cy={1149.8} r={5.56} className="cls-2bi2" />
        <circle cx={610.68} cy={1103.92} r={5.56} className="cls-2bi2" />
        <circle cx={474.62} cy={1170.99} r={5.56} className="cls-2bi2" />
        <circle cx={777.18} cy={1085.46} r={20.74} className="cls-2bi2" />
        <path
          d="M957.96 391.19c-.45 3.81-.89 7.62-1.34 11.44-.57 4.83-1.13 9.66-1.7 14.49-.92 7.9-1.85 15.8-2.78 23.7-.57 4.83-1.13 9.66-1.7 14.49-.92 7.9-1.85 15.8-2.78 23.69-.57 4.83-1.13 9.66-1.7 14.49l-2.25 19.18c-.54 4.61-3.46 8-6.9 8H580.5c-2.96 0-5.61-2.55-6.59-6.34-2.16-8.32-3.9-15.04-5.41-20.84-1.42-5.45-2.62-10.1-3.76-14.49-1.98-7.63-3.77-14.54-6.15-23.69-1.1-4.24-2.33-8.97-3.76-14.49-.24-.93-.49-1.89-.74-2.87-1.52-5.86 1.44-12.08 6-12.61l71.14-8.22 125.44-14.49 193.81-22.38c4.52-.52 8.21 4.86 7.49 10.94Z"
          className="cls-2bi1"
        />
        <path
          d="m918.93 303.7-.73 9.98-1.15 15.76-1.06 14.5c-.14 1.97-.48 3.84-1 5.54-1.63 5.43-4.94 9.3-8.86 9.92-12.47 1.95-24.95 3.91-37.42 5.86-42.68 6.68-85.36 13.35-128.04 20.03-49.2 7.7-98.4 15.39-147.59 23.09-6.48 1-12.08-7.11-12.08-17.47V301.7c0-2.9.44-5.63 1.23-8.04 1.82-5.65 5.52-9.51 9.79-9.51h315.99c4.31 0 7.97 3.91 9.79 9.51.96 2.97 1.4 6.45 1.14 10.06Z"
          className="cls-2bi2"
        />
        <circle cx={609.36} cy={472.39} r={18.35} className="cls-2bi2" />
        <circle cx={800.53} cy={417.56} r={9.24} className="cls-2bi2" />
        <circle cx={729.48} cy={475.09} r={29.95} className="cls-2bi2" />
        <circle cx={796.65} cy={490.74} r={10.98} className="cls-2bi2" />
        <circle cx={918.79} cy={458.5} r={17.56} className="cls-2bi2" />
        <circle cx={837.25} cy={454.04} r={15.35} className="cls-2bi2" />
        <circle cx={657.5} cy={433.55} r={6.75} className="cls-2bi2" />
        <circle cx={655.46} cy={505.04} r={6.75} className="cls-2bi2" />
        <circle cx={873.98} cy={422.9} r={8.37} className="cls-2bi2" />
        <circle cx={909.61} cy={542.44} r={11.62} className="cls-2bi2" />
        <circle cx={851.68} cy={498.47} r={7.44} className="cls-2bi2" />
        <circle cx={901.21} cy={457.88} r={7.44} className="cls-2bi2" />
        <circle cx={722.05} cy={426.79} r={7.44} className="cls-2bi2" />
        <path
          d="m918.93 303.7-.73 9.98H581v-11.99c0-2.9.44-5.63 1.23-8.04H917.8c.96 2.97 1.4 6.45 1.14 10.06ZM917.05 329.43l-1.06 14.5c-.14 1.97-.48 3.84-1 5.54h-334v-20.03h336.05ZM868.71 365.24c-42.68 6.68-85.36 13.35-128.04 20.03H581v-20.03h287.72ZM759.43 194.4v11.56l-23.78 5.76v-11.56l23.78-5.76zM759.43 216.33v11.56l-23.78 5.76v-11.56l23.78-5.76zM759.43 238.27v11.56l-23.78 5.76v-11.56l23.78-5.76zM759.43 260.21v11.56l-23.78 5.76v-11.56l23.78-5.76zM738.74 176.94c-4.83-5.74-.59-19.45 11.56-33.93.15 3.97.69 9.43 2.38 15.66 3.01 11.06 7.07 15.05 5.11 18.38-2.67 4.51-14.75 4.99-19.04-.12Z"
          className="cls-2bi3"
        />
        {children}
      </g>
    </svg>
  );
}
